import React, { useState } from 'react';
import { Typography, Box, TextField, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import ShieldIcon from '@mui/icons-material/ShieldOutlined';
import RefreshIcon from '@mui/icons-material/RefreshOutlined';
import { submitShareLight } from 'pages/ShareYourLight/api';
import { handleApiError, trackMixpanelEvent } from 'utils/utilMethods';
import CommonModal from 'pages/ShareYourLight/components/CommonModal';
import ConfirmCloseModal from 'pages/ShareYourLight/components/ConfirmCloseModal';
import SYLButton from 'pages/ShareYourLight/components/SYLButton';
import { useMutation } from 'react-query';
import http from 'utils/http';
import CommunityRulesModal from 'pages/ShareYourLight/components/CommunityRulesModal';
import Theme from 'theme';
import { MixpanelEventName } from 'utils/constants';

const urlRegex = /^(?:(?:[a-zA-Z][a-zA-Z0-9+.-]*):\/\/)?(?:localhost|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(?::\d+)?(?:\/[^\s]*)?$/;

function CrisisIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={35} height={35} viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g transform='scale(0.945,0.945) translate(0.5,0.5)'>
        <path d='M19.8548 26.124H17.1464C16.7979 26.124 16.5567 26.4733 16.6802 26.7996C16.7764 27.0535 16.9304 27.3213 17.1427 27.5293C17.5305 27.9089 17.9826 28.0983 18.4992 28.0983C19.0157 28.0983 19.4885 27.9089 19.8682 27.5293C20.0768 27.3206 20.2285 27.0512 20.3225 26.7959C20.4424 26.4696 20.2026 26.124 19.8548 26.124Z' fill='#CAA360' />
        <path d='M26.0885 24.5094L25.6045 24.0987C24.7387 23.3647 24.24 22.2865 24.24 21.1513V16.5078C24.24 15.1832 23.8359 13.9844 23.0286 12.9107C22.316 11.9635 21.4095 11.3271 20.3076 11.0015C20.0398 10.9223 19.8555 10.6774 19.8555 10.3984V10.1853C19.8555 9.81379 19.7223 9.50669 19.4559 9.26471C19.1895 9.02273 18.8706 8.90137 18.4991 8.90137C18.1276 8.90137 17.8087 9.02273 17.5423 9.26471C17.2759 9.50669 17.1426 9.81379 17.1426 10.1853V10.3984C17.1426 10.6774 16.9584 10.9223 16.6905 11.0015C15.5894 11.3271 14.6866 11.9627 13.9814 12.9107C13.1822 13.9844 12.7826 15.184 12.7826 16.5078V21.1373C12.7826 22.2806 12.2764 23.3647 11.401 24.0995L10.9133 24.5087C10.7846 24.6167 10.7409 24.7966 10.8068 24.9512C10.8408 25.0311 10.8904 25.1037 10.9548 25.168C11.0924 25.3049 11.2656 25.3738 11.4757 25.3738H25.5254C25.7355 25.3738 25.9087 25.3049 26.0463 25.168C26.1151 25.0992 26.1669 25.0208 26.201 24.9335C26.2602 24.784 26.2121 24.613 26.0892 24.5087L26.0885 24.5094ZM17.671 11.1658C17.8982 10.9349 18.175 10.8194 18.5006 10.8194C18.8261 10.8194 19.1044 10.9349 19.336 11.1658C19.5669 11.3966 19.6823 11.6749 19.6823 12.0012C19.6823 12.2661 19.6409 12.5407 19.5573 12.8248C19.4774 13.0979 19.2961 13.624 19.0126 14.404C18.9919 14.4625 18.9364 14.5009 18.8743 14.5009H18.1246C18.0632 14.5009 18.0085 14.4632 17.987 14.4055C17.705 13.6544 17.5252 13.1364 17.449 12.853C17.3698 12.5577 17.3299 12.2735 17.3299 12.0005C17.3299 11.6749 17.4438 11.3966 17.671 11.165V11.1658ZM19.3871 16.251C19.3871 16.5012 19.302 16.7113 19.131 16.8815C18.9608 17.0517 18.7507 17.1376 18.5006 17.1376C18.2504 17.1376 18.0403 17.0525 17.8701 16.8815C17.6999 16.7113 17.614 16.5012 17.614 16.251C17.614 16.0009 17.6991 15.7908 17.8701 15.6206C18.0403 15.4504 18.2504 15.3645 18.5006 15.3645C18.7507 15.3645 18.9608 15.4496 19.131 15.6206C19.3012 15.7915 19.3871 16.0009 19.3871 16.251ZM16.7963 14.0066C16.8178 14.0769 16.8422 14.1509 16.8696 14.2279L17.0361 14.6941C17.0553 14.7481 17.0413 14.808 17.0006 14.848C16.8215 15.0226 16.6809 15.2232 16.5795 15.4496C16.4655 15.7034 16.4093 15.9743 16.4093 16.2621C16.4093 16.8453 16.6121 17.3381 17.0176 17.7392C17.4231 18.141 17.9174 18.3415 18.5006 18.3415C19.0837 18.3415 19.578 18.141 19.9835 17.7392C20.389 17.3374 20.5918 16.8453 20.5918 16.2621C20.5918 15.9743 20.5348 15.7034 20.4216 15.4496C20.3195 15.2224 20.1818 15.0204 20.0065 14.845C19.968 14.8066 19.9546 14.7503 19.9709 14.6985C20.0279 14.515 20.0797 14.3544 20.1256 14.2168C20.1515 14.1391 20.1759 14.0658 20.1981 13.997C20.2307 13.8978 20.3528 13.8631 20.4327 13.9304C20.7531 14.199 21.0084 14.5135 21.1993 14.8761C21.4228 15.3001 21.5345 15.7626 21.5345 16.2621C21.5345 17.1028 21.2408 17.8191 20.654 18.4096C20.0671 19.0009 19.3493 19.2961 18.5006 19.2961C17.6518 19.2961 16.934 19.0009 16.3471 18.4096C15.7603 17.8184 15.4665 17.1028 15.4665 16.2621C15.4665 15.7619 15.5783 15.3001 15.8018 14.8761C15.9912 14.5172 16.2443 14.2042 16.561 13.9371C16.6417 13.869 16.766 13.906 16.7963 14.0066ZM23.1707 18.2335C22.9058 18.8507 22.5439 19.3886 22.0851 19.8474C21.6271 20.3055 21.0891 20.6659 20.4712 20.9271C19.854 21.1883 19.1969 21.3193 18.4998 21.3193C17.8027 21.3193 17.1456 21.1883 16.5285 20.9271C15.9113 20.6659 15.3733 20.3062 14.9145 19.8474C14.4564 19.3894 14.0946 18.8514 13.8297 18.2335C13.5648 17.6163 13.4323 16.9592 13.4323 16.2621C13.4323 15.2624 13.6994 14.3455 14.2337 13.5123C14.7191 12.7553 15.3644 12.1707 16.1718 11.757C16.2746 11.7045 16.396 11.7837 16.3864 11.8984C16.3797 11.979 16.376 12.0604 16.376 12.1426C16.376 12.2832 16.3893 12.4312 16.4145 12.5843C16.4248 12.6435 16.396 12.7027 16.3442 12.7338C15.7418 13.1001 15.2675 13.5878 14.9212 14.199C14.5578 14.8391 14.3758 15.5266 14.3758 16.2614C14.3758 17.4054 14.7776 18.3771 15.5805 19.1763C16.3834 19.9755 17.3573 20.3751 18.5006 20.3751C19.6439 20.3751 20.6177 19.9755 21.4206 19.1763C22.2235 18.3771 22.6253 17.4054 22.6253 16.2614C22.6253 15.5192 22.4418 14.8295 22.074 14.1931C21.7233 13.5856 21.2467 13.0994 20.6443 12.7338C20.5925 12.7027 20.5644 12.6435 20.574 12.5843C20.6014 12.4186 20.6184 12.2676 20.6251 12.1315C20.6288 12.053 20.628 11.9738 20.6229 11.8947C20.6155 11.7814 20.7368 11.7045 20.8382 11.757C21.6389 12.1699 22.2819 12.7553 22.7674 13.5123C23.3017 14.3455 23.5688 15.2624 23.5688 16.2621C23.5688 16.9592 23.4363 17.6163 23.1714 18.2335H23.1707Z' fill='#CAA360' />
        <path d='M18.5003 0.951172C8.80849 0.951172 0.951172 8.80849 0.951172 18.5003C0.951172 28.1921 8.80849 36.0494 18.5003 36.0494C28.1921 36.0494 36.0494 28.1921 36.0494 18.5003C36.0494 8.80849 28.1921 0.951172 18.5003 0.951172ZM22.2928 11.1735L23.8571 12.7379C24.0688 12.9495 24.4114 12.9495 24.6223 12.7379L28.622 8.73819C28.8418 8.51841 29.2007 8.52729 29.4079 8.75891C31.7189 11.3452 33.1242 14.7588 33.1242 18.5003C33.1242 26.5922 26.5959 33.1219 18.5047 33.1242C14.7648 33.1256 11.3526 31.7226 8.76631 29.4138C8.53469 29.2073 8.52581 28.8477 8.74559 28.6279L10.694 26.6795C10.9057 26.4679 10.9057 26.1252 10.694 25.9143L9.11263 24.333C8.90173 24.1221 8.55985 24.1213 8.34821 24.3315L6.70541 25.9647C6.45455 26.214 6.03497 26.1608 5.85663 25.8551C4.59715 23.6943 3.87565 21.1813 3.87565 18.5003C3.87565 10.4202 10.4557 3.85641 18.5358 3.87639C21.225 3.88305 23.7439 4.61491 25.9062 5.88771C26.2118 6.06753 26.2629 6.48933 26.0105 6.73871L22.295 10.4062C22.0811 10.6171 22.0804 10.9619 22.2928 11.1743V11.1735Z' fill='#F46868' />
      </g>
    </svg>
  );
}

interface ShareYourLightModalProps {
  open: boolean;
  onClose: () => void;
}

// Random name generator based on CompassionateMouse32145
function generateRandomName() {
  const adjectives = [
    'Active', 'Artistic', 'Calm', 'Serene', 'Peaceful', 'Clever', 'Considerate', 'Resilient', 'Incredible', 'Graceful',
    'Friendly', 'Happy', 'Imaginative', 'Bold', 'Brilliant', 'Bright', 'Reflective', 'Confident', 'Beautiful', 'Supportive',
    'Amazing', 'Vivacious', 'Adaptable', 'Luminous', 'Capable', 'Comfortable', 'Courageous', 'Sparkling', 'Enthusiastic',
    'Fantastic', 'Funny', 'Splendid', 'Twinkling', 'Joyous', 'Lively', 'Optimistic', 'Philosophical', 'Upbeat', 'Beaming',
    'Resourceful', 'Thoughtful', 'Wily', 'Adventurous', 'Boundless', 'Knowing', 'Communicative', 'Creative', 'Dynamic',
    'Exuberant', 'Fearless', 'Generous', 'Helpful', 'Intellectual', 'Kind', 'Loving', 'Outgoing', 'Polite', 'Quiet',
    'Resourceful', 'Sensitive', 'Trustworthy', 'Willing', 'Affectionate', 'Brave', 'Caring', 'Compassionate', 'Curious',
    'Eager', 'Expressive', 'Sage', 'Gentle', 'Hilarious', 'Intelligent', 'Kind-hearted', 'Loyal', 'Passionate', 'Practical',
    'Rational', 'Responsible', 'Skillful', 'Understanding', 'Witty', 'Perceptive', 'Rosy', 'Cheerful', 'Conscientious',
    'Decisive', 'Energetic', 'Fabulous', 'Frank', 'Gregarious', 'Honest', 'Intuitive', 'Knowledgeable', 'Golden', 'Patient',
    'Versatile', 'Wonderful',
  ];
  const animals = [
    'Penguin', 'Chickadee', 'Puffin', 'Hummingbird', 'Canary', 'Budgie', 'Finch', 'Toucan', 'Peacock', 'Owl',
    'Duckling', 'Goose', 'Flamingo', 'Macaw', 'Quail', 'Dog', 'Cat', 'Rabbit', 'Hamster', 'Ferret',
    'Pig', 'Monkey', 'Marmoset', 'Fox', 'Panda', 'Puppy', 'Lizard', 'Snake', 'Salamander', 'Squirrel',
    'Chinchilla', 'Hedgehog', 'Otter', 'Quokka', 'Mink', 'Koala', 'Panda', 'Wombat', 'Bushbaby', 'Lemur',
    'Dolphin', 'Seal', 'Whale', 'Orca', 'Mouse', 'Squirrel', 'Chipmunk', 'Raccoon', 'Deer', 'Giraffe',
    'Elephant', 'Tiger', 'Lion', 'Wolf', 'Puma', 'Cheetah', 'Jaguar', 'Macaque', 'Gibbon', 'Axolotl',
    'Turtle', 'Frog', 'Iguana', 'Gecko', 'Chameleon', 'Cobra', 'Crocodile', 'Seahorse', 'PufferFish', 'ClownFish',
    'AngelShark', 'Ladybug', 'Butterfly', 'Bee', 'Ant', 'Dolphin', 'Octopus', 'Starfish', 'Crab', 'Lobster',
    'Shrimp', 'Rhinoceros', 'Zebra', 'Buffalo', 'Cow', 'HoneyBadger', 'Aardvark', 'Ostrich', 'Stork', 'Impala',
    'Gazelle', 'Baboon', 'Gorilla', 'Lemur', 'Robin', 'Parrot', 'Swan', 'Pigeon',
  ];
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const animal = animals[Math.floor(Math.random() * animals.length)];
  const number = Math.floor(100 + Math.random() * 900);
  return `${adjective}${animal}${number}`;
}
const ShareYourLightModalTitle = React.memo(({ step }: { step: number }) => {
  if (step === 1) {
    return (
      <Typography variant='h6' mb={4} fontSize={20} color='#FED892' fontWeight={400} textAlign='center'>
        Share your light
      </Typography>
    );
  }
  if (step === 2) {
    return (
      <Typography
        variant='h6'
        sx={{ color: '#FED892', mb: 6, fontSize: 20, textAlign: 'center' }}
        maxWidth={400}
        fontWeight={400}
      >
        Add your email to get notified when your message is approved.
      </Typography>
    );
  }
  return (
    <Typography
      variant='h4'
      sx={{
        color: '#FED892',
        fontWeight: 400,
        fontSize: 20,
        textAlign: 'center',
      }}
    >
      Thank you!
    </Typography>
  );
});

function ShareYourLightModal({
  open,
  onClose,
  csrfToken,
  refetchCsrfToken,
}: ShareYourLightModalProps & { csrfToken: string, refetchCsrfToken: () => Promise<string> }) {
  const [step, setStep] = useState(1);
  const [input, setInput] = useState('');
  const [title, setTitle] = useState('');
  const [email, setEmail] = useState('');
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState('');
  const [titleError, setTitleError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [rulesOpen, setRulesOpen] = useState(false);
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);
  const [randomName, setRandomName] = useState(() => generateRandomName());

  // Reset state when modal opens/closes
  React.useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setStep(1);
        setInput('');
        setTitle('');
        setEmail('');
        setChecked(false);
        setError('');
        setTitleError('');
        setEmailError('');
        setShowSuccess(false);
      }, 300);
    }
  }, [open]);

  // Intercept close to show confirmation if not submitted
  const handleRequestClose = () => {
    if (showSuccess || (!input.trim() && !email)
    ) {
      onClose();
    }
    else {
      setConfirmCloseOpen(true);
    }
  };

  const handleConfirmClose = () => {
    setConfirmCloseOpen(false);
    onClose();
  };

  const submitShareLightMutation = useMutation(
    async (
      payload: { content: string; email?: string; consent?: boolean; title: string, name: string },
    ) => {
      // First attempt with current csrfToken
      const trySubmitShareLight = async (
        token: string,
        attempts: number,
      ) => {
        try {
          return await submitShareLight(http.post)({ ...payload, csrfToken: token });
        }
        catch (err) {
          if (err instanceof Error && ['CSRF token is invalid', 'missing CSRF token'].includes(err.message) && attempts < 1) {
            const newToken = await refetchCsrfToken() || token;
            if (newToken) {
              return submitShareLight(http.post)({ ...payload, csrfToken: newToken });
            }
          }
          throw err;
        }
      };

      return trySubmitShareLight(csrfToken, 0);
    },
    {
      onSuccess: () => {
        setShowSuccess(true);
        setStep(0);
      },
      onError: (err) => {
        handleApiError(err, 'ShareYourLightModal: Failed to submit message', setError);
      },
    },
  );

  const handleFirstStep = () => {
    setTitleError('');
    setError('');

    let hasError = false;
    const trimmedTitle = title.trim();
    const trimmedInput = input.trim();

    if (urlRegex.test(trimmedTitle)) {
      setTitleError('Please do not include links or URLs in your title.');
      hasError = true;
    }

    if (!trimmedInput) {
      setError('Please enter your message.');
      hasError = true;
    }
    else if (urlRegex.test(trimmedInput)) {
      setError('Please do not include links or URLs in your message.');
      hasError = true;
    }

    if (hasError) return;

    setStep(2);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setEmailError('');
  };

  const handleSubmit = (withEmail: boolean) => {
    if (withEmail) {
      if (!email.trim()) {
        setEmailError('Please enter your email address.');
        return;
      }
      // Simple email validation
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setEmailError('Please enter a valid email address.');
        return;
      }
    }
    const first10Words = input.trim().split(/\s+/).slice(0, 10).join(' ');
    submitShareLightMutation.mutate({
      content: input,
      email: withEmail ? email : undefined,
      consent: withEmail ? checked : undefined,
      title: title || `${first10Words}...`,
      name: randomName,
    });
  };

  return (
    <>
      <CommonModal
        open={open}
        onClose={handleRequestClose}
        paperSx={{ maxWidth: 520 }}
        title={<ShareYourLightModalTitle step={step} />}
      >
        <CommunityRulesModal open={rulesOpen} onClose={() => setRulesOpen(false)} />
        {step === 1 && (
        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
          <Typography color='#DADADA' fontSize={18} mb={4} textAlign='center'>
            Your words can brighten someone’s darkest night.
            Share a message of hope to light a new lamp.
          </Typography>
          <Box sx={{ position: 'relative', width: '100%' }}>
            <Box className='fs-mask'>
              <TextField
                placeholder='Add a title for your message (optional)'
                fullWidth
                value={title}
                onChange={({ target: { value } }) => {
                  if (value.length <= 50) {
                    setTitle(value);
                  }
                }}
                error={!!titleError}
                helperText={
                  titleError && (
                    <span style={{ color: '#F25D51', fontSize: '1rem' }}>{titleError}</span>
                  )
                }
                disabled={submitShareLightMutation.isLoading}
                inputProps={{ maxLength: 50, style: { color: '#fff', fontSize: 18 } }}
                sx={{
                  mb: 1,
                  '& .MuiInputBase-root': {
                    color: '#fff',
                    fontSize: 18,
                    borderRadius: 2,
                  },
                  '& .MuiInputLabel-root': { color: '#FED892' },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: titleError
                      ? '#F25D51'
                      : Theme.custom.colors.lightTextSecondary,
                  },
                  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#F25D51',
                  },
                  '& .MuiFormHelperText-root': { color: '#FED892', fontSize: 14 },
                }}
              />
            </Box>
            <Box
              sx={{
                textAlign: 'right',
                mr: 0.5,
                mb: 1.5,
                color: title.length >= 50 ? '#FED892' : '#888',
                fontSize: 13,
                pointerEvents: 'none',
              }}
            >
              {`${title.length}/50`}
            </Box>
            <Box className='fs-mask'>
              <TextField
                placeholder='Type a message of hope...'
                multiline
                minRows={4}
                fullWidth
                value={input}
                onChange={({ target: { value } }) => {
                  if (value.length <= 2000) {
                    setInput(value);
                  }
                }}
                error={!!error}
                helperText={
                  error && (
                    <span style={{ color: '#F25D51', fontSize: '1rem' }}>{error}</span>
                  )
                }
                disabled={submitShareLightMutation.isLoading}
                inputProps={{ maxLength: 2000, style: { color: '#fff', fontSize: 18 } }}
                sx={{
                  mb: 1,
                  '& .MuiInputBase-root': {
                    color: '#fff',
                    fontSize: 18,
                    borderRadius: 2,
                  },
                  '& .MuiInputLabel-root': { color: '#FED892' },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: error
                      ? '#F25D51'
                      : Theme.custom.colors.lightTextSecondary,
                  },
                  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#F25D51',
                  },
                  '& .MuiFormHelperText-root': { color: '#F25D51', fontSize: 14 },
                }}
              />
            </Box>
            <Box display='flex' justifyContent='space-between' alignItems='center' mb={4} flexWrap='wrap' gap={1}>
              <Box display='flex' alignItems='center' alignSelf='flex-start' gap={1} flexWrap='wrap'>
                <Typography fontSize={18} color='#fff' sx={{ fontWeight: 500 }} fontStyle='italic' whiteSpace='nowrap'>
                  -
                  {' '}
                  {randomName}
                </Typography>
                <IconButton onClick={() => setRandomName(generateRandomName())}>
                  <RefreshIcon sx={{ color: '#FED892', fontSize: 24, fontWeight: 700 }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  textAlign: 'right',
                  mr: 0.5,
                  color: (input.length) >= 2000 ? '#FED892' : '#888',
                  fontSize: 13,
                  pointerEvents: 'none',
                }}
              >
                {`${(input.length)}/2000`}
              </Box>
            </Box>
          </Box>

          {/* margin below the field to match previous spacing */}
          <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
            <ShieldIcon sx={{ color: '#FED892', fontSize: 24, fontWeight: 700 }} />
            <Typography
              fontSize={14}
              color='#fff'
              sx={{
                fontWeight: 500,
              }}
            >
              Review the
              {' '}
              <Typography
                component='span'
                color='#FED892'
                fontSize={14}
                sx={{ fontWeight: 500, cursor: 'pointer', ':hover': { textDecoration: 'underline' } }}
                onClick={() => {
                  trackMixpanelEvent(MixpanelEventName.SHAREYOURLIGHT_COMMUNITY_RULES_LINK_CLICKED);
                  setRulesOpen(true);
                }}
              >
                Community Rules
              </Typography>
              {' '}
              before submitting
            </Typography>
          </Box>
          <SYLButton
            variant='contained'
            onClick={() => {
              trackMixpanelEvent(MixpanelEventName.SHAREYOURLIGHT_SUBMIT_BUTTON_CLICKED);
              handleFirstStep();
            }}
            disabled={submitShareLightMutation.isLoading}
            sx={{ maxWidth: 250, width: '100%' }}
          >
            SUBMIT
          </SYLButton>
          <Box
            sx={{
              mt: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
            }}
          >
            <CrisisIcon style={{ verticalAlign: 'middle' }} />
            <Typography
              fontSize={14}
              color='#CDCDCD'
              fontWeight={500}
              flexShrink={2}
            >
              This is not a substitute for professional medical advice. If you are in crisis,
              {' '}
              <Typography
                component='span'
                color='#FED892'
                fontSize={14}
                sx={{ fontWeight: 500 }}
              >
                please call or text 988
              </Typography>
              {' '}
              (U.S. Suicide and Crisis Lifeline) or your local emergency number.
              Conversations here are peer support only.
              They are not therapy, treatment, or professional counseling.
            </Typography>
          </Box>
        </Box>
        )}
        {step === 2 && (
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          width='100%'
        >
          <Box className='fs-mask' width='100%'>
            <TextField
              placeholder='Enter your email address'
              fullWidth
              value={email}
              onChange={handleEmailChange}
              error={!!emailError}
              helperText={
              emailError && (
                <span style={{ color: '#F25D51', fontSize: '1rem' }}>{emailError}</span>
              )
              }
              disabled={submitShareLightMutation.isLoading}
              sx={{
                mb: 1.5,
                '& .MuiInputBase-root': { color: '#fff', fontSize: 18, borderRadius: 2 },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: emailError
                    ? '#F25D51'
                    : Theme.custom.colors.lightTextSecondary,
                },
                '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#F25D51',
                },
                '& .MuiFormHelperText-root': { color: '#FED892', fontSize: 14 },
              }}
              InputProps={{ style: { color: '#fff', fontSize: 18 } }}
            />
          </Box>
          <FormControlLabel
            control={(
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
                sx={{ color: '#fff' }}
                disabled={submitShareLightMutation.isLoading}
              />
            )}
            label={(
              <Typography sx={{ color: '#fff', fontSize: 14 }}>
                By checking this box you agree to receiving marketing & other communications from
                Headlamp.
              </Typography>
            )}
            sx={{ alignSelf: 'flex-start', mb: 3, mx: 1 }}
          />
          {error && (
          <Typography color='error' mb={1} textAlign='left' width='100%'>
            {error}
          </Typography>
          )}
          <SYLButton
            variant='contained'
            onClick={() => {
              trackMixpanelEvent(MixpanelEventName.SHAREYOURLIGHT_EMAIL_SUBMIT_BUTTON_CLICKED);
              handleSubmit(true);
            }}
            disabled={submitShareLightMutation.isLoading || (!!checked && !email)}
            sx={{ mb: 3, maxWidth: 250, width: '100%' }}
          >
            SUBMIT
          </SYLButton>
          <SYLButton
            variant='text'
            onClick={() => {
              trackMixpanelEvent(MixpanelEventName.SHAREYOURLIGHT_SKIP_BUTTON_CLICKED);
              handleSubmit(false);
            }}
            disabled={submitShareLightMutation.isLoading || !!email || !!checked}
            sx={{
              color: '#948976',
              fontWeight: 500,
              fontSize: 15,
              '&.Mui-disabled': { color: '#888' },
            }}
          >
            SKIP
          </SYLButton>
        </Box>
        )}
        {showSuccess && (
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          my={6}
        >
          <Box mb={1.5}>
            <span style={{ fontSize: 48, color: '#FFB816' }}>★</span>
          </Box>
          <Typography sx={{ color: '#fff', fontSize: 18, fontWeight: 400, textAlign: 'center' }}>
            Your message will go live after it’s
            <br />
            reviewed and approved.
          </Typography>
        </Box>
        )}
      </CommonModal>
      <ConfirmCloseModal
        open={confirmCloseOpen}
        onCancel={() => setConfirmCloseOpen(false)}
        onConfirm={handleConfirmClose}
      />
    </>
  );
}


export default ShareYourLightModal;
